import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
`

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`

export const SectionTitle = styled.h3`
  color: #14171f;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
  padding: 0 4px;
`

export const SectionContent = styled.div`
  background-color: white;
  border-radius: 12px;
  border: 1px solid #f0f2f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
`

export const ItemWrapper = styled.div`
  width: 100%;
`

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  transition: background-color 0.2s ease;
  border-radius: 8px;
`

export const ItemText = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 400;
`

export const Divider = styled.div`
  height: 1px;
  background-color: #f0f2f5;
  margin: 0 16px;
`

export const DeleteButton = styled.button`
  width: 100%;
  padding: 16px;

  border-radius: 12px;

  border: 1px solid #ef4444;
  background-color: transparent;
  color: #ef4444;
  font-size: 14px;
  font-weight: 400;

  cursor: pointer;

  transition: background-color 0.2s ease;

  &:hover {
    background-color: #fef2f2;
  }

  &:active {
    background-color: #fee2e2;
  }
`
